import { Fragment, h } from 'preact';
import { useCallback, useEffect, useRef, useState } from 'preact/hooks';
import { usePlayerContext, useStyles } from '../../../../../common/hooks';
import { Button } from '../../../common';
import { Modal } from '../../../common/modal';
import Tracks from './Tracks';

import { MODAL_CLOSING_BUTTON_STYLE } from '../../../common/modal/types';
import {
  TRACKLIST_MODAL_BASIC_STYLE,
  TRACK_DIALOG_CLOSE_LABEL_STYLE
} from './styles';

import { USER_CLICK, USER_TRACK_LIST_CLOSED, USER_TRACK_LIST_OPENED } from '../../../../../../types';
import { isMultilang } from '../../../../../../utils/tracks';
import { useOpenDialogsCounter, useRegisterDialog } from '../../../../../common/context/DialogContext';
import { handleCloseModalButton } from '../../../../utils/modal';

export const LABEL_AUDIO_ET_SOUS_TITRES = 'Audio et sous-titres';
function TracksMenu({
  hidden,
  subtitlesAvailable,
  subtitleSelected,
  audiosAvailable,
  audioSelected,
  name,
  disableFocus,
  isTv,
  ...extraProps
}) {
  const player = usePlayerContext();
  const setStyles = useStyles();

  const iconRef = useRef(null);
  const closeIconRef = useRef(null);

  const [isOutsideModal, setIsOutsideModal] = useState(null);
  const [isModalOpened, setIsModalOpened] = useState(false);

  useRegisterDialog({
    id: name, openingMode: 'click', state: [isModalOpened, setIsModalOpened]
  });
  useOpenDialogsCounter(isModalOpened);

  const size = setStyles({
    extraSmall: { width: 16 },
    small: { width: 24 },
    medium: { width: 36 },
    'large+extraLarge': { width: 44 },
    'largeTv+extraLargeTv': { width: 60 }
  }).width;

  const modalWrapperStyles = setStyles({
    default: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' },
    'medium+large+extraLarge': { position: 'relative' }
  });
  const modalStyles = setStyles({
    'medium+large+extraLarge': { top: 'initial', bottom: -5, right: -5, width: 505, maxWidth: 650, maxHeight: 600 }
  });

  const closingButtonStyle = {
    ...setStyles(MODAL_CLOSING_BUTTON_STYLE),
    ...setStyles({
      'default+extraSmall': { top: 21, right: 0 },
      small: { top: 26, right: 21 },
      medium: { top: 22, right: 21 },
      'large+extraLarge': { top: 30, right: 20 }
    })
  };

  const closeButtonLabelStyle = setStyles(TRACK_DIALOG_CLOSE_LABEL_STYLE);

  const handleCloseModal = (event) => {
    handleCloseModalButton({
      event,
      player,
      currentIconRef: iconRef.current,
      setIsModalOpened,
      closedAction: USER_TRACK_LIST_CLOSED
    });
  };

  const onClickOpen = useCallback(() => {
    // Local state
    setIsModalOpened((state) => !state);

    // Store state
    player.userEvents$.next({
      action: USER_TRACK_LIST_OPENED,
      source: USER_CLICK,
      value: isMultilang(audiosAvailable, subtitlesAvailable)
    });
  }, [setIsModalOpened]);

  useEffect(() => {
    if (isModalOpened && closeIconRef.current) {
      setIsOutsideModal(false);
      closeIconRef.current?.focus();
    }
  }, [isModalOpened, isOutsideModal]);

  return !hidden && (
    <Fragment>
      <Button
        type="icon"
        name={name}
        icon={isTv ? 'tracks-active' : 'tracks'}
        label={LABEL_AUDIO_ET_SOUS_TITRES}
        size={size}
        onClick={onClickOpen}
        iconRef={iconRef}
        openingMode="click"
        {...extraProps}
      />

      {isModalOpened && (
        <div style={modalWrapperStyles}>
          <Modal
            show={isModalOpened}
            trap
            attachedTo={name}
            onChange={(openedState) => {
              setIsOutsideModal(true);
              setIsModalOpened(openedState);
            }}
            onEscapeKeyDown={handleCloseModal}
            styles={TRACKLIST_MODAL_BASIC_STYLE}
            stylesDirectOverride={modalStyles}
            closingButtonStyle={closingButtonStyle}
            closeComponent={(
              <Button
                type="icon"
                openingMode="click"
                label="Fermer"
                forceLabel
                disableFocus={false}
                ariaLabel={`Fermer ${LABEL_AUDIO_ET_SOUS_TITRES}`}
                last
                zone="right"
                onClick={handleCloseModal}
                size={setStyles({
                  extraSmall: { width: 16 },
                  'small+medium+large+extraLarge': { width: 24 }
                }).width}
                icon="close"
                xs
                iconRef={closeIconRef}
                name="btn-close-tracks-modal"
                ariaHidden={false}
                labelStyle={closeButtonLabelStyle}
              />
            )}
          >
            <Tracks
              subtitlesAvailable={subtitlesAvailable}
              subtitleSelected={subtitleSelected}
              audiosAvailable={audiosAvailable}
              audioSelected={audioSelected}
              isTv={isTv}
            />
          </Modal>
        </div>
      )}
    </Fragment>
  );
}

export default TracksMenu;
